<template>
  <section class="used-by-section bg-lighter py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center used-by-heading">
          Art Grab is used by music industry leaders like:
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 logo-wrapper">
          <div class="used-by-logo">
            <img src="/img/logos/universal-music-group.png" alt="Universal Music Group">
          </div>
          <div class="used-by-logo">
            <img src="/img/logos/sony-music.png" alt="Sony Music">
          </div>
          <div class="used-by-logo">
            <img src="/img/logos/ultra-music.png" alt="Ultra Music">
          </div>
          <div class="used-by-logo">
            <img src="/img/logos/redlight-management.png" alt="Redlight Management">
          </div>
          <div class="used-by-logo">
            <img src="/img/logos/monstercat.png" alt="Monstercat">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "used-by",
};
</script>

<style scoped lang="scss">
.used-by-section {
  .used-by-heading {
    color: #8898aa;
  }

  .logo-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;

    .used-by-logo {
      padding: 8px 2px;

      img {
        max-height: 75px;
        max-width: 200px;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .used-by-section {
    .used-by-heading {
      padding: 0 80px;
    }
  }
}
</style>
